import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { TablePagination, TableSortLabel } from "@mui/material";

const ROWS_PER_PAGE = 10;

interface Props {
  tableHeadings: { [key: string]: string };
  rows: any[];
}

const FlaggedFraudUsersTable = ({ tableHeadings, rows }: Props) => {
  const headCells = Object.entries(tableHeadings);
  const [page, setPage] = React.useState(0);

  // Drop back to the first page if the row set shrinks below the current one
  React.useEffect(() => {
    setPage(0);
  }, [rows]);

  const isPaginated = rows.length > ROWS_PER_PAGE;
  const visibleRows = isPaginated
    ? rows.slice(page * ROWS_PER_PAGE, page * ROWS_PER_PAGE + ROWS_PER_PAGE)
    : rows;

  return (
    <>
      <Paper sx={{ boxShadow: "none" }}>
        <TableContainer className="">
          <Table size="small" stickyHeader>
            <TableHead>
              <TableRow>
                {headCells.map(([_, value], index) => (
                  <TableCell
                    key={index}
                    align="left"
                    sx={{ whiteSpace: "nowrap" }}
                  >
                    <TableSortLabel>
                      {value && typeof value === "string" ? value : ""}
                    </TableSortLabel>
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {visibleRows.map((row, rowIndex) => (
                <React.Fragment key={rowIndex}>
                  <TableRow
                    sx={{
                      "& > *": {
                        borderBottom:
                          "1px solid rgba(224, 224, 224, 1) !important",
                      },
                    }}
                  >
                    {headCells.map(([key], cellIndex) => (
                      <TableCell key={cellIndex} align="left">
                        {key === "user_unique_id" ? (
                          <> {row[key] ? row[key] : "N/A"}</>
                        ) : key === "flagged_on" ? (
                          <> {row[key] ? row[key] : "N/A"}</>
                        ) : key === "flagged_by" ? (
                          <> {row[key] ? row[key] : "N/A"}</>
                        ) : (
                          "N/A"
                        )}
                      </TableCell>
                    ))}
                  </TableRow>
                </React.Fragment>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        {isPaginated && (
          <TablePagination
            component="div"
            count={rows.length}
            page={page}
            onPageChange={(_, newPage) => setPage(newPage)}
            rowsPerPage={ROWS_PER_PAGE}
            rowsPerPageOptions={[ROWS_PER_PAGE]}
            sx={{
              ".MuiTablePagination-toolbar": { minHeight: 40, pl: 1 },
              ".MuiTablePagination-selectLabel, .MuiTablePagination-input": {
                display: "none",
              },
              ".MuiTablePagination-displayedRows": { fontSize: 12 },
            }}
          />
        )}
      </Paper>
    </>
  );
};

export default FlaggedFraudUsersTable;
